/* SKYTTA */
export const CUSTOMIZE_MENU_BACK_BUTTON = 'customizeMenuBackButton';
export const CUSTOMIZE_MENU_SKYTTA_TITLE = 'customizeMenuSkyttaTitle';
export const ADD_STOPBARS_LABEL = 'add-stopbars-label';
export const ADD_STOPBARS_SWITCH = 'add-stopbars-switch';
export const DOOR_LAYOUT_MESSAGE_LABEL = 'door-layout-message-label';
export const RAILS_LABEL = 'rails-label';
export const FAQ_LINK_LABEL = 'faq-link-label';
export const RECOMMENDED_DEPTH_LABEL = 'recommended-depth-label';
export const CUSTOMIZE_MENU_CONTENT = 'customizeMenuContent';

/**
 * Active accordion
 */
export const ACTIVE_ACCORDION_ITEM = '.accordion__item--active';

/**
 * Scene
 */
export const RENDER_CANVAS = 'renderCanvas';

/* Cypress */
export enum DataTestIdEnum {
  DoorLayoutsTitle = 'door-layouts-title',
  OpenDesignButton = 'open-design-button',
  StartPlannerButton = 'start-planner-button',
  ReachIn = 'ReachIn',
  WalkIn = 'WalkIn',
  RoomDivider = 'RoomDivider',
  MobileNavigation = 'mobile-navigation',
  LoadingScreen = 'loading-screen',
  ProductCardGrid = 'product-card-grid',
  ImportedStorageImage = 'importedStorageImage',
  StorageBehindRecommendation = 'storageBehindRecommendation',
  StorageBehindShowMoreButton = 'storageBehindShowMoreButton',
  BuyStorageBehindButton = 'buyStorageBehindButton',
  MeasurementWidgets = 'measurementWidgets',
  ContinuePlanningCard = 'continuePlanningCard',
  StartNewDesignCard = 'startNewDesignCard',
  StorageBehindCard = 'storageBehindCard',
  StorageBehindContinueButton = 'storageBehindContinueButton'
}

export enum Lists {
  CustomizeMenuList = 'customizeMenuList',
  FaqAccordionList = 'faqAccordionList',
  Debug = 'debug',
  Menu = 'MenuSheetContent',
  DoorHeights = 'doorHeightsList'
}
